module.exports = __webpack_public_path__ + "img/cy.b3ef7d78.svg";